export const ALERTS = `alerts`;
export const ALERTSCONTENT = `${ALERTS}-content`;
export const ALERTSCOMPOSE = `${ALERTS}-compose`;
export const ALERTS_CONTAINER = `${ALERTS}-container`;

export const ALERTS_NAVHEADER_TEXT = `${ALERTSCONTENT}-navheader-text`;
export const ALERTS_NAVBAR_CONTAINER = `${ALERTS}-navbar-container`;

export const ALERTS_CONTENT_CONTAINER = `${ALERTSCONTENT}-container`;
export const ALERTS_CONTENT_INNER_CONTAINER = `${ALERTSCONTENT}-inner-container`;
export const ALERTS_CONTENT_EMPTY = `${ALERTSCONTENT}-empty`;
export const ALERTS_CONTENT_TITLE_CONTAINER = `${ALERTSCONTENT}-title-container`;
export const ALERTS_CONTENT_TITLE = `${ALERTSCONTENT}-title`;
export const ALERTS_CONTENT_SUBTITLE = `${ALERTSCONTENT}-subtitle`;
export const ALERTS_CONTENT_DATE = `${ALERTSCONTENT}-date`;
export const ALERTS_CONTENT_TIME_MOBILE_CONTAINER = `${ALERTSCONTENT}-time-mobile-container`;
export const ALERTS_CONTENT_TIME = `${ALERTSCONTENT}-time`;
export const ALERTS_CONTENT_EXPIRES = `${ALERTSCONTENT}-expires`;
export const ALERTS_CONTENT_DIVIDER = `${ALERTSCONTENT}-divider`;
export const ALERTS_CONTENT_MAP_INNER_CONTAINER = `${ALERTSCONTENT}-map-inner-container`;

export const ALERTS_CONTENT_MAP_CONTAINER = `${ALERTSCONTENT}-map-container`;
export const ALERTS_CONTENT_INFO_DETAILS_CONTAINER = `${ALERTSCONTENT}-info-details-container`;
export const ALERTS_CONTENT_INFO_CONTAINER = `${ALERTSCONTENT}-info-container`;
export const ALERTS_CONTENT_INFO_DESCRIPTION = `${ALERTSCONTENT}-info-description`;
export const ALERTS_CONTENT_INFO_INSTRUCTIONS = `${ALERTSCONTENT}-info-instructions`;
export const ALERTS_CONTENT_INFO_INNER_CONTAINER = `${ALERTSCONTENT}-info-inner-container`;

export const ALERTS_CONTENT_DETAILS_CONTAINER = `${ALERTSCONTENT}-details-container`;
export const ALERTS_CONTENT_DETAILS_OUTER_CONTAINER = `${ALERTSCONTENT}-details-outer-container`;
export const ALERTS_CONTENT_DETAILS_HEADERS = `${ALERTSCONTENT}-details-headers`;
export const ALERTS_CONTENT_DETAILS_HEADER = `${ALERTSCONTENT}-details-header`;
export const ALERTS_CONTENT_DETAILS_DESCRIPTIONS = `${ALERTSCONTENT}-details-descriptions`;
export const ALERTS_CONTENT_DETAILS_DESCRIPTION = `${ALERTSCONTENT}-details-description`;
export const ALERTS_CONTENT_DETAILS_IMAGE = `${ALERTSCONTENT}-details-image`;

export const ALERTS_CONTENT_DETAILS_FOOTER_CONTAINER = `${ALERTSCONTENT}-details-footer-container`;
export const ALERTS_CONTENT_DETAILS_FOOTER_INNER_CONTAINER = `${ALERTSCONTENT}-details-footer-inner-container`;

export const ALERTS_CONTENT_DETAILS_CANCEL = `${ALERTSCONTENT}-details-cancel`;
export const ALERTS_CONTENT_DETAILS_UPDATE = `${ALERTSCONTENT}-details-update`;

export const ALERTS_CONTENT_COMPOSE_CONTAINER = `${ALERTSCONTENT}-compose-container`;
export const ALERTS_CONTENT_COMPOSE_HEADER = `${ALERTSCONTENT}-compose-header`;
export const ALERTS_CONTENT_COMPOSE_FOOTER = `${ALERTSCONTENT}-compose-footer`;
export const ALERTS_CONTENT_COMPOSE_CONTENT_CONTAINER = `${ALERTSCONTENT}-compose-content-container`;
export const ALERTS_CONTENT_COMPOSE_CONTENT_INNER_CONTAINER = `${ALERTSCONTENT}-compose-content-inner-container`;
export const ALERTS_CONTENT_COMPOSE_CHANNEL_BOX_CONTAINER = `${ALERTSCONTENT}-compose-channel-box-container`;
export const ALERTS_CONTENT_COMPOSE_MORE_INFO = `${ALERTSCONTENT}-compose-more-info`;

export const ALERTS_CONTENT_COMPOSE_CHOOSE_AUDIENCE_HEADER = `${ALERTSCONTENT}-compose-choose-audience-header`;
export const ALERTS_CONTENT_COMPOSE_CHOOSE_AUDIENCE_SUB_HEADER = `${ALERTSCONTENT}-compose-choose-audience-sub-header`;

export const ALERTS_CONTENT_COMPOSE_SELECT_CHANNELS = `${ALERTSCONTENT}-compose-select-channels`;
export const ALERTS_CONTENT_COMPOSE_CHOOSE_AUDIENCE = `${ALERTSCONTENT}-compose-choose-audience`;
export const ALERTS_CONTENT_COMPOSE_SENDER_DETAILS = `${ALERTSCONTENT}-compose-sender-details`;
export const ALERTS_CONTENT_COMPOSE_ALERT_DETAILS = `${ALERTSCONTENT}-compose-alert-details`;
export const ALERTS_CONTENT_COMPOSE_MESSAGE = `${ALERTSCONTENT}-compose-message`;
export const ALERTS_CONTENT_COMPOSE_PREVIEW_SEND = `${ALERTSCONTENT}-compose-preview-send`;

export const ALERTS_CONTENT_COMPOSE_CONTENT = `${ALERTSCONTENT}-compose-content`;
export const ALERTS_CONTENT_COMPOSE_SUBTITLE_CONTAINER = `${ALERTSCONTENT}-compose-subtitle-container`;
export const ALERTS_CONTENT_COMPOSE_SUBTITLE = `${ALERTSCONTENT}-compose-subtitle`;
export const ALERTS_CONTENT_COMPOSE_TABS_CONTAINER = `${ALERTSCONTENT}-compose-tabs-container`;
export const ALERTS_CONTENT_COMPOSE_TABS = `${ALERTSCONTENT}-compose-tabs`;
export const ALERTS_CONTENT_COMPOSE_INPUT_CONTAINER = `${ALERTSCONTENT}-compose-subtitle`;
export const ALERTS_CONTENT_COMPOSE_MAP_CONTAINER = `${ALERTSCONTENT}-compose-map-container`;
export const ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER = `${ALERTSCONTENT}-compose-block-container`;
export const ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER = `${ALERTSCONTENT}-compose-block-inner-container`;
export const ALERTS_CONTENT_COMPOSE_INNER_SUBTITLE = `${ALERTSCONTENT}-compose-inner-subtitle`;

export const ALERTS_CONTENT_ANALYTICS_CONTAINER = `${ALERTSCONTENT}-analytics-container`;
export const ALERTS_CONTENT_ANALYTICS = `${ALERTSCONTENT}-analytics`;
export const ALERTS_CONTENT_ANALYTICS_ITEM = `${ALERTSCONTENT}-analytics-item`;
export const ALERTS_CONTENT_ANALYTICS_NUMBER = `${ALERTSCONTENT}-analytics-number`;

const ALERTS_CONTENT_FROSTED = `${ALERTSCONTENT}-frosted`;
export const ALERTS_CONTENT_FROSTED_CONTAINER = `${ALERTS_CONTENT_FROSTED}-container`;
export const ALERTS_CONTENT_FROSTED_MOBILE_CONTAINER = `${ALERTS_CONTENT_FROSTED}-mobile-container`;
export const ALERTS_CONTENT_FROSTED_INNER_CONTAINER = `${ALERTS_CONTENT_FROSTED}-inner-container`;

export const ALERTS_LIST_ITEM = `alerts-list-item`;
export const ALERTS_LIST_ITEM_CONTAINER = `alerts-list-item-container`;
export const ALERTS_LIST_ITEM_INNER_CONTAINER = `alerts-list-item-inner-container`;
export const ALERTS_LIST_ITEM_DESCRIPTION_CONTAINER = `${ALERTS_LIST_ITEM}-description-container`;
export const ALERTS_LIST_ITEM_DESCRIPTION = `${ALERTS_LIST_ITEM}-description`;

export const ALERTS_LIST_ITEM_HEADER = `${ALERTS_LIST_ITEM}-header`;
export const ALERTS_LIST_ITEM_HEADER_TOP = `${ALERTS_LIST_ITEM}-header-top`;
export const ALERTS_LIST_ITEM_HEADER_TYPE = `${ALERTS_LIST_ITEM}-header-type`;
export const ALERTS_LIST_ITEM_HEADER_DATE = `${ALERTS_LIST_ITEM}-header-date`;
export const ALERTS_LIST_ITEM_HEADER_TITLE = `${ALERTS_LIST_ITEM}-header-title`;
export const ALERTS_LIST_ITEM_HEADER_TITLE_UNDERLINE = `${ALERTS_LIST_ITEM}-header-title-underline`;

export const ALERTS_DRAFTS_LIST_ITEM = `alerts-drafts-list-item`;
export const ALERTS_DRAFTS_LIST_ITEM_CONTAINER = `${ALERTS_DRAFTS_LIST_ITEM}-container`;
export const ALERTS_DRAFTS_LIST_ITEM_INNER_CONTAINER = `${ALERTS_DRAFTS_LIST_ITEM}-inner-container`;
export const ALERTS_DRAFTS_LIST_ITEM_DESCRIPTION_CONTAINER = `${ALERTS_DRAFTS_LIST_ITEM}-description-container`;
export const ALERTS_DRAFTS_LIST_ITEM_DESCRIPTION = `${ALERTS_DRAFTS_LIST_ITEM}-description`;

export const ALERTS_DRAFTS_LIST_ITEM_HEADER = `${ALERTS_DRAFTS_LIST_ITEM}-header`;
export const ALERTS_DRAFTS_LIST_ITEM_HEADER_TOP = `${ALERTS_DRAFTS_LIST_ITEM}-header-top`;
export const ALERTS_DRAFTS_LIST_ITEM_HEADER_TYPE = `${ALERTS_DRAFTS_LIST_ITEM}-header-type`;
export const ALERTS_DRAFTS_LIST_ITEM_BOTTOM = `${ALERTS_DRAFTS_LIST_ITEM}-bottom`;
export const ALERTS_DRAFTS_LIST_ITEM_HEADER_TITLE = `${ALERTS_DRAFTS_LIST_ITEM}-header-title`;
export const ALERTS_DRAFTS_LIST_ITEM_HEADER_TITLE_UNDERLINE = `${ALERTS_DRAFTS_LIST_ITEM}-header-title-underline`;

export const ALERTS_SCHEDULED_LIST_ITEM = `alerts-scheduled-list-item`;
export const ALERTS_SCHEDULED_LIST_ITEM_CONTAINER = `${ALERTS_SCHEDULED_LIST_ITEM}-container`;
export const ALERTS_SCHEDULED_LIST_ITEM_INNER_CONTAINER = `${ALERTS_SCHEDULED_LIST_ITEM}-inner-container`;
export const ALERTS_SCHEDULED_LIST_ITEM_DESCRIPTION_CONTAINER = `${ALERTS_SCHEDULED_LIST_ITEM}-description-container`;
export const ALERTS_SCHEDULED_LIST_ITEM_DESCRIPTION = `${ALERTS_SCHEDULED_LIST_ITEM}-description`;

export const ALERTS_SCHEDULED_LIST_ITEM_HEADER = `${ALERTS_SCHEDULED_LIST_ITEM}-header`;
export const ALERTS_SCHEDULED_LIST_ITEM_HEADER_TOP = `${ALERTS_SCHEDULED_LIST_ITEM}-header-top`;
export const ALERTS_SCHEDULED_LIST_ITEM_HEADER_TYPE = `${ALERTS_SCHEDULED_LIST_ITEM}-header-type`;
export const ALERTS_SCHEDULED_LIST_ITEM_BOTTOM = `${ALERTS_SCHEDULED_LIST_ITEM}-bottom`;
export const ALERTS_SCHEDULED_LIST_ITEM_HEADER_TITLE = `${ALERTS_SCHEDULED_LIST_ITEM}-header-title`;
export const ALERTS_SCHEDULED_LIST_ITEM_HEADER_TITLE_UNDERLINE = `${ALERTS_SCHEDULED_LIST_ITEM}-header-title-underline`;



// WEBPACK FOOTER //
// ./src/controllers/alerts/classes.ts